var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {},
    [
      _c("v-modal-contents", {
        ref: "modal_contents_agree",
        scopedSlots: _vm._u([
          {
            key: "close",
            fn: function () {
              return [_c("div")]
            },
            proxy: true,
          },
          {
            key: "title",
            fn: function () {
              return [
                _c("div", { staticClass: "terms_of_use__title" }, [
                  _c("div", { staticClass: "h2_title" }, [
                    _vm._v("Условия использования персональных данных"),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "content",
            fn: function () {
              return [
                _c("div", { staticClass: "terms_of_use mt-30 " }, [
                  _c("div", { domProps: { innerHTML: _vm._s(_vm.terms) } }),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-30" }, [
                    _c(
                      "button",
                      {
                        staticClass: "px-30 btn-red ",
                        on: {
                          click: function ($event) {
                            return _vm.$refs.modal_contents_agree.modal_open()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                        Прочитал\n                    "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "v-form",
        {
          ref: "form",
          staticClass: "form_anticorruption ",
          attrs: { "lazy-validation": "" },
          model: {
            value: _vm.valid,
            callback: function ($$v) {
              _vm.valid = $$v
            },
            expression: "valid",
          },
        },
        [
          _c(
            "div",
            { staticClass: "row mx-0 my-0" },
            [
              _vm._t("description", function () {
                return [
                  _c("div", { staticClass: "col-12 col-md-6 col-lg-6 p-md-2" }),
                ]
              }),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 col-md-6 col-lg  p-0" }, [
                _c("div", { staticClass: "col-12 col-md-12" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "form_anticorruption__item position-relative",
                    },
                    [
                      _c("v-text-field", {
                        staticClass: "form_anticorruption__input",
                        attrs: { rules: [_vm.rules.required, _vm.rules.city] },
                        scopedSlots: _vm._u([
                          {
                            key: "label",
                            fn: function () {
                              return [
                                _vm._v(
                                  "\n                                Город *\n                            "
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                        model: {
                          value: _vm.city,
                          callback: function ($$v) {
                            _vm.city = $$v
                          },
                          expression: "city",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mx-0 my-0" }, [
                  _c("div", { staticClass: "col-12 col-md-6 " }, [
                    _c(
                      "div",
                      { staticClass: "form_anticorruption__item role" },
                      [
                        _c("v-select", {
                          staticClass: "form_anticorruption__input",
                          attrs: {
                            items: _vm.roleRu,
                            "item-value": "id",
                            label: "Ваша роль *",
                            required: "",
                            rules: [_vm.rules.required],
                            "append-icon": "mdi mdi-chevron-down",
                            id: "role",
                            "menu-props": { contentClass: "wrapp_role" },
                            "return-object": "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "item",
                              fn: function (ref) {
                                var item = ref.item
                                return [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(item.name) +
                                      "\n                                "
                                  ),
                                ]
                              },
                            },
                            {
                              key: "selection",
                              fn: function (ref) {
                                var item = ref.item
                                return [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(item.name) +
                                      "\n                                "
                                  ),
                                ]
                              },
                            },
                          ]),
                          model: {
                            value: _vm.select_role,
                            callback: function ($$v) {
                              _vm.select_role = $$v
                            },
                            expression: "select_role",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-md-6 " }, [
                    _c(
                      "div",
                      { staticClass: "form_anticorruption__item role" },
                      [
                        _c("v-select", {
                          staticClass: "form_anticorruption__input",
                          attrs: {
                            items: _vm.themeRu,
                            "item-value": "id",
                            label: "Тема *",
                            required: "",
                            rules: [_vm.rules.required],
                            "append-icon": "mdi mdi-chevron-down",
                            id: "role",
                            "menu-props": { contentClass: "wrapp_role" },
                            "return-object": "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "item",
                              fn: function (ref) {
                                var item = ref.item
                                return [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(item.name) +
                                      "\n                                "
                                  ),
                                ]
                              },
                            },
                            {
                              key: "selection",
                              fn: function (ref) {
                                var item = ref.item
                                return [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(item.name) +
                                      "\n                                "
                                  ),
                                ]
                              },
                            },
                          ]),
                          model: {
                            value: _vm.select_theme,
                            callback: function ($$v) {
                              _vm.select_theme = $$v
                            },
                            expression: "select_theme",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mx-0 my-0" }, [
                  _c("div", { staticClass: "col-12 col-md-6 " }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "form_anticorruption__item item_tel position-relative",
                      },
                      [
                        _c("v-text-field", {
                          directives: [
                            {
                              name: "mask",
                              rawName: "v-mask",
                              value: "# ### ###-##-##",
                              expression: "'# ### ###-##-##'",
                            },
                          ],
                          staticClass: " form_anticorruption__input",
                          attrs: {
                            id: "tel",
                            oninput:
                              "this.value = this.value.replace(/^\\(8/, '(');",
                            max: "20",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "\n                                    Телефон\n                                "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.tel,
                            callback: function ($$v) {
                              _vm.tel = $$v
                            },
                            expression: "tel",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-md-6" }, [
                    _c(
                      "div",
                      { staticClass: "form_anticorruption__item" },
                      [
                        _c("v-text-field", {
                          staticClass: "form_anticorruption__input",
                          attrs: {
                            oninput: "this.value = this.value.trim()",
                            id: "email",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "\n                                    Электронная почта\n                                "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.email,
                            callback: function ($$v) {
                              _vm.email = $$v
                            },
                            expression: "email",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-md-12 " }, [
                  _c(
                    "div",
                    { staticClass: "form_anticorruption__item" },
                    [
                      _c("v-textarea", {
                        staticClass: "form_anticorruption__input",
                        attrs: {
                          id: "comment",
                          rows: "3",
                          rules: [_vm.rules.required, _vm.rules.comment],
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "label",
                            fn: function () {
                              return [
                                _vm._v(
                                  "\n                                Комментарий *\n                            "
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                        model: {
                          value: _vm.comment,
                          callback: function ($$v) {
                            _vm.comment = $$v
                          },
                          expression: "comment",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-md-12 pb-3 px-3 pt-3" }, [
                  _c("div", { staticClass: "form_anticorruption__item " }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "summary p-12 bg-gray-100 border border-gray-300 drag_form d-flex flex-column justify-content-center",
                        attrs: { id: "summary" },
                        on: {
                          dragover: _vm.dragover,
                          dragleave: _vm.dragleave,
                          drop: _vm.drop,
                        },
                      },
                      [
                        _c("input", {
                          ref: "file",
                          staticClass:
                            "w-px h-px opacity-0 overflow-hidden absolute",
                          attrs: {
                            type: "file",
                            multiple: "",
                            name: "fields[assetsFieldHandle][]",
                            id: "assetsFieldHandle",
                            accept:
                              ".pdf,.jpg,.jpeg,.png,.rtf,.doc,.docx,.xls,.xlsx",
                          },
                          on: { change: _vm.onChange },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "block cursor-pointer",
                            attrs: { for: "assetsFieldHandle" },
                          },
                          [
                            _c("div", [
                              _vm._v(
                                "Выберите или перетащите сюда файл в формате PDF, RTF,\n                                    JPG\n                                    DOC, DOCX, XLS, XLSX.\n                                    "
                              ),
                              _c("div", [
                                _vm._v(
                                  "Для передачи нескольких файлов осуществите их одновременную загрузку."
                                ),
                              ]),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        this.filelist.length
                          ? _c(
                              "ul",
                              { staticClass: "mt-4" },
                              _vm._l(_vm.filelist, function (file, index) {
                                return _c(
                                  "li",
                                  {
                                    key: index,
                                    staticClass: "text-sm p-1 text-left",
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(file.name) +
                                        "\n                                    "
                                    ),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "ml-2 remove_file",
                                        attrs: {
                                          type: "button",
                                          title: "Remove file",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.remove(
                                              _vm.filelist.indexOf(file)
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        Удалить\n                                    "
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              }),
                              0
                            )
                          : _vm._e(),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-md-12 pb-3 px-3 pt-3" }, [
                  _c("div", {
                    staticClass: "w-100 mt-30",
                    class: _vm.captchaPassed ? "" : "error-captcha",
                    attrs: { id: "captcha-container" },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form_upload__item  mt-30" },
                    [
                      _c("v-checkbox", {
                        attrs: {
                          rules: [
                            function (v) {
                              return !!v || "Это обязательный пункт"
                            },
                          ],
                          required: "",
                          color: "red",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "label",
                            fn: function () {
                              return [
                                _c("div", { staticClass: "customLabelForm" }, [
                                  _vm._v(
                                    "\n                                    Я выражаю согласие с\n                                    "
                                  ),
                                  _c(
                                    "a",
                                    {
                                      attrs: { href: "javascript:void(0);" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.$refs.modal_contents_agree.modal_open(
                                            "scroll_false"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                        условиями использования"
                                      ),
                                    ]
                                  ),
                                  _vm._v(
                                    "\n                                    персональных данных для обработки данного обращения ООО «Компания Нова Ролл»\n                                    (ИНН 5038050970, адрес: 141206, Московская область, г. Пушкино, Кудринское\n                                    шоссе, д. 2а, стр. 5, этаж 2), я ознакомлен и выражаю согласие с\n                                    "
                                  ),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "position-relative zi-1",
                                      attrs: { href: _vm.policy },
                                      on: {
                                        click: function ($event) {
                                          return _vm.linkOpen(_vm.policy)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                        Политикой конфиденциальности\n                                    "
                                      ),
                                    ]
                                  ),
                                  _vm._v(
                                    " и\n                                    "
                                  ),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "position-relative zi-1",
                                      attrs: { href: _vm.agreement },
                                      on: {
                                        click: function ($event) {
                                          return _vm.linkOpen(_vm.agreement)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                        Пользовательским соглашением.\n                                    "
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                        model: {
                          value: _vm.checkbox,
                          callback: function ($$v) {
                            _vm.checkbox = $$v
                          },
                          expression: "checkbox",
                        },
                      }),
                      _vm._v(" "),
                      _c("v-checkbox", {
                        staticClass: "mt-0",
                        attrs: { color: "red" },
                        scopedSlots: _vm._u([
                          {
                            key: "label",
                            fn: function () {
                              return [
                                _c("div", { staticClass: "customLabelForm" }, [
                                  _vm._v(
                                    "\n                                    Я выражаю согласие на информирование меня о продуктах, акциях, выгодных\n                                    предложениях, новостях ООО «Компания Нова Ролл» (ИНН 5038050970, адрес: 141206,\n                                    Московская область, г. Пушкино, Кудринское шоссе, д. 2а, стр. 5, этаж 2) и\n                                    партнеров.\n                                "
                                  ),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                        model: {
                          value: _vm.consentToInform,
                          callback: function ($$v) {
                            _vm.consentToInform = $$v
                          },
                          expression: "consentToInform",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "btn_form d-flex align-items-center justify-content-start ",
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: " btn-red w-mc",
                              attrs: { disabled: !_vm.valid },
                              on: { click: _vm.sendForm },
                            },
                            [
                              _vm._v(
                                "\n                                Отправить\n                            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }